import React, { useContext, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Custom Components
import DraggableDialog from '@/ui/Dialog/DraggableDialog';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogContext, {
  IDialogProps,
} from '@/context/DialogContext/DialogContext';

// Types
import { DCRecord } from '@/@types/lib/dataController';

const KomunalneStatusDialog: FunctionComponent<IDialogProps> = (props) => {
  const { hideDialog } = useContext(DialogContext);
  const { t } = useTranslation();

  const { fields } = props;

  const handleClose = () => {
    hideDialog();
  };

  return (
    <DraggableDialog open maxWidth="lg" onClose={handleClose}>
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>
            {t('ena:komunalni_obveznici.status_view')}
          </DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent>
        <Box m={2}>
          {fields &&
            fields !== null &&
            fields.map((item: DCRecord) => (
              <div key={`kom-stat-item-wrapper-${item.id}`}>
                <li key={`kom-stat-item-${item.id}`}>{`${item.status}: ${item.opis}`}</li>
              </div>
            ))}
        </Box>
      </DialogContent>
      <DialogActions />
    </DraggableDialog>
  );
};

export default KomunalneStatusDialog;
